import { Injectable } from '@angular/core';
import { Market } from './interface';
import { map, Observable, of, shareReplay, switchMap } from 'rxjs';
import { RestrictedGroupService } from '@galaxy/crm/static';
import { PartnerCRMSalespersonMarketService } from '../../salesperson-market.service';
import { ALL_MARKETS_DEFAULT } from '../../../constants';

@Injectable({ providedIn: 'root' })
export class MarketFilterService {
  constructor(
    private readonly restrictedGroupService: RestrictedGroupService,
    private readonly marketsService: PartnerCRMSalespersonMarketService,
  ) {}

  private currentMarket$ = this.getCurrentGroupId().pipe(
    switchMap((groupId) => this.marketsService.getMarket(groupId)),
    shareReplay(1),
  );

  getCurrentGroupId(): Observable<string> {
    return this.restrictedGroupService.getCurrentGroupId();
  }

  getCurrentMarket(): Observable<Market> {
    return this.currentMarket$;
  }

  getAllMarkets(): Observable<Market[]> {
    const markets$ = this.marketsService.getMarkets() ?? of([]);
    return markets$.pipe(
      // filter out '_DEFAULT' market, which is set to be 'All Markets', and should not be shown in the CRM filter dropdown
      map((markets) => markets.filter((m) => m.market_id !== ALL_MARKETS_DEFAULT)),
    );
  }
}
